<template>
  <v-container class="login_form" >
    <v-form v-if="!isLogging">
      <v-text-field class="login_text_field"
        label="Login:"
        v-model="login"
        type="email"/>
      <v-text-field class="login_text_field"
        label="Mot de passe:"
        v-model="password"
        type="password"/>
      <v-btn @click="logon">Connexion</v-btn>
    </v-form>
    <!-- Indicateur de chargement (cercle) -->
    <v-progress-circular v-else indeterminate color="primary" size="120" />
    <div class="text-bottom">Lynx App / © Invivoo 2024</div>
  <InstallPWA/>
  </v-container>
</template>

<script>
import { AuthServiceInstance, RefServiceInstance } from '@/lynxapi'
import InstallPWA from '@/components/InstallPWA.vue'

export default {
  components: {
    InstallPWA
  },
  data () {
    return {
      login: '',
      password: '',
      isLogging: false // Variable pour indiquer si le chargement est en cours
    }
  },
  methods: {
    pause (ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    async logon () {
      this.isLogging = true // Démarrage du chargement
      try {
        await AuthServiceInstance.storeCredentials(this.login, this.password)
        const res = await AuthServiceInstance.login(this.login, this.password)
        if (res === true) {
          const initres = await RefServiceInstance.InitReferential()
          if (initres === true) {
            this.$router.push('/dashboard/welcome')
          }
        }
      } finally {
        this.isLogging = false // Fin du chargement
      }
    }
  },
  mounted () {
    AuthServiceInstance.retrieveCredentials().then((cred) => {
      if (cred) {
        this.login = cred.login
        this.password = cred.password
      }
    })
  }
}
</script>

<style scoped>
.login_form {
  width: auto;
}

.login_text_field {
  background-color: rgba(255,255,255,0.9);
  margin-bottom: 1vh;
}
.text-bottom {
  margin-top: 1vh;
  color: beige;
}
</style>
